// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import searchLabsSelector from '../../redux/selectors/searchLabsSelector';
import { actionCreatorsList } from '../../redux/rootActionCreator';
import { ProductCard } from '../../components/NewCard/types';
import { KeywordTitle } from '../../redux/actionCreators/search/searchLabsKeywordActions';
import { SearchCondition } from '../../types/Model';

const {
  searchLabsActions,
  searchLabsKeywordActions
} = actionCreatorsList;

export function useSearchLabs(limit: number, page: number, condition: SearchCondition): () => void {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(searchLabsActions.request({
      limit,
      page,
      condition
    }));
  }, [page, condition])
}

export function useSearchLabsKeywords(limit: number, name: string): () => void {
  const dispatch = useDispatch();

  return useCallback(() => {
    if (name.length > 0) {
      dispatch(searchLabsKeywordActions.request({
        limit,
        name
      }));
    }
  }, [limit, name])
}

export function useIsFetching(): boolean {
  return useSelector(searchLabsSelector.makeIsFetching())
}

export function useLabsList(): ProductCard[] {
  return useSelector(searchLabsSelector.makeSearchLabs());
}

export function useError(): Error | undefined {
  return useSelector(searchLabsSelector.makeError());
}

export function useKeywords(keyword: string): KeywordTitle[] {
  return useSelector(searchLabsSelector.makeSearchKeywordByKey(keyword));
}

export function useHasMoreResults(): boolean {
  return useSelector(searchLabsSelector.makeHasMore());
}

export function useIsMoreFetching(): boolean {
  return useSelector(searchLabsSelector.makeIsMoreFetching())
}

export function useCommonKeywords(keyword: string): KeywordTitle[] {
  return useSelector(searchLabsSelector.makeSearchCommonKeywordByKey(keyword))
}
